import { observer } from 'mobx-react';
import { SvgIcon } from '@execonline-inc/execonline-ui';

function GroupExperiencesIcon() {
  return (
    <SvgIcon size="xl" viewBox="0 0 48 47">
      <g opacity="0.9">
        <path
          d="M14.3035 9.85645C11.59 9.85645 9.36133 12.0851 9.36133 14.7986V41.7558C9.36133 44.4692 11.59 46.6979 14.3035 46.6979H43.0578C45.7713 46.6979 47.9999 44.4692 47.9999 41.7558V14.7986C47.9999 12.0851 45.7713 9.85645 43.0578 9.85645H14.3035ZM12.057 17.9436H45.3042V41.7558C45.3042 43.0122 44.3142 44.0022 43.0578 44.0022H14.3035C13.0471 44.0022 12.057 43.0122 12.057 41.7558V17.9436Z"
          fill="#252425"
        />
        <path
          d="M40.0015 7.87028C39.182 6.27262 37.5209 5.17456 35.6051 5.17456H9.54653C6.82116 5.17456 4.60438 7.39134 4.60438 10.1167V38.871C4.60438 40.7868 5.70244 42.4479 7.3001 43.2674V12.8124C7.3001 10.1167 9.54653 7.87028 12.2422 7.87028H40.0015Z"
          fill="#252425"
        />
        <path
          d="M35.3979 2.99772C34.5785 1.40006 32.9174 0.302002 31.0016 0.302002H4.94301C2.21764 0.302002 0.000865936 2.51878 0.000865936 5.24415V33.9985C0.000865936 35.9142 1.09892 37.5753 2.69658 38.3948V7.93987C2.69658 5.24415 4.94301 2.99772 7.63873 2.99772H35.3979Z"
          fill="#252425"
        />
        <path
          d="M15.6543 23.6145H21.9154C22.4914 23.6145 22.9589 22.8873 22.9589 21.9913C22.9589 21.0952 22.4914 20.368 21.9154 20.368H15.6543C15.0783 20.368 14.6108 21.0952 14.6108 21.9913C14.6108 22.8873 15.0783 23.6145 15.6543 23.6145Z"
          fill="#252425"
        />
        <path
          d="M25.3926 23.6145H31.6536C32.2297 23.6145 32.6972 22.8873 32.6972 21.9913C32.6972 21.0952 32.2297 20.368 31.6536 20.368H25.3926C24.8166 20.368 24.3491 21.0952 24.3491 21.9913C24.3491 22.8873 24.8166 23.6145 25.3926 23.6145Z"
          fill="#252425"
        />
        <path
          d="M37.5679 28.4871H16.6978C15.5458 28.4871 14.6108 27.7599 14.6108 26.8638C14.6108 25.9678 15.5458 25.2406 16.6978 25.2406H37.5679C38.7199 25.2406 39.6549 25.9678 39.6549 26.8638C39.6549 27.7599 38.7199 28.4871 37.5679 28.4871Z"
          fill="#252425"
        />
        <path
          d="M23.5386 41.0073H15.4225C14.9744 41.0073 14.6108 40.2801 14.6108 39.3841C14.6108 38.4881 14.9744 37.7609 15.4225 37.7609H23.5386C23.9866 37.7609 24.3502 38.4881 24.3502 39.3841C24.3502 40.2801 23.9866 41.0073 23.5386 41.0073Z"
          fill="#252425"
        />
      </g>
    </SvgIcon>
  );
}

export default observer(GroupExperiencesIcon);
